import { CampaignQuantityBySocialNetwork, Selector } from '@hub/shared'
import { useCallback, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import './social-network-filter.component.scoped.scss'
import { SqLoader } from '@squidit/react-css'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  onChange?: (value: any) => any
  loading?: boolean
  quantity?: CampaignQuantityBySocialNetwork | null
}

export default ({ className = '', style = {}, id = '', onChange, loading, quantity }: Props) => {
  const [t] = useTranslation('socialNetworkFilter')
  const [state, setState] = useState({
    value: '',
  })
  const socialNetworks = useMemo(
    () => [
      {
        value: '',
        name: t('all'),
        icon: 'fa-solid fa-rectangle-vertical-history',
        key: 'all',
      },
      {
        value: 'instagram',
        name: 'Instagram',
        icon: 'fa-brands fa-instagram',
        key: 'instagram',
      },
      {
        value: 'youtube',
        name: 'Youtube',
        icon: 'fa-brands fa-youtube',
        key: 'youtube',
      },
      {
        value: 'tiktok',
        name: 'TikTok',
        icon: 'fa-brands fa-tiktok',
        key: 'tiktok',
      },
      {
        value: 'twitter',
        name: 'Twitter',
        icon: 'fa-brands fa-x-twitter',
        key: 'twitter',
      },
    ],
    [t]
  )

  const handleChange = useCallback(
    (value: string): void => {
      setState((prevState) => ({ ...prevState, value }))
      if (onChange && typeof onChange === 'function') {
        onChange(value)
      }
    },
    [onChange]
  )

  return (
    <section className={`social-network-filter pt-2 ${className}`} style={style} id={id}>
      {socialNetworks?.map((socialNetwork, index) => (
        <Selector
          name={`social-network-${socialNetwork.key}${state.value === socialNetwork.value ? '-checked' : ''}`}
          id={`social-network-${socialNetwork.key}${state.value === socialNetwork.value ? '-checked' : ''}`}
          className="social-network"
          key={`${index}-${socialNetwork?.key}`}
          value={socialNetwork.value}
          checked={state.value === socialNetwork.value}
          onChange={(checked: boolean) => {
            if (!loading && checked) {
              handleChange(socialNetwork.value)
            }
          }}
          type={'radio'}
          hideInput
          errorSpan={false}
          rightLabel={
            <div className={`social-network-filter-card ${state.value === socialNetwork.value ? 'active' : ''}`}>
              {loading && state.value === socialNetwork.value ? (
                <SqLoader className="mb-2" size="small" />
              ) : (
                <span>
                  <i className={`${socialNetwork.icon} mb-2 position-relative`} style={{ fontSize: 18 }}>
                    {quantity && quantity[socialNetwork?.key] > 0 ? (
                      <span
                        className="badge background-blue-dark white px-1 rounded over-element top-right"
                        style={{ textAlign: 'center' }}
                      >
                        {(quantity as any)[socialNetwork.key]}
                      </span>
                    ) : null}
                  </i>
                </span>
              )}
              <p className="mb-1" style={{ fontSize: '0.85rem', fontWeight: 500 }}>
                {socialNetwork.name}
              </p>
            </div>
          }
        />
      ))}
    </section>
  )
}
